import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { getDevices, getUserSettings } from '@/api/apiService'
import { QueryKeys } from '../models/enum'
import { DeviceDto, ResponseObject, UseGetReadModel, UserSettingsDto } from '../models/types'

function devicesService(): UseQueryResult<DeviceDto[], AxiosError<ResponseObject>> {
    return useQuery<DeviceDto[], AxiosError<ResponseObject>>({
        queryKey: [QueryKeys.Devices],
        queryFn: getDevices,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    })
}

export function useGetDevices(): UseGetReadModel<DeviceDto[]> {
    const { isLoading, error, data = [] } = devicesService()
    return {
        isLoading,
        data: data,
        error,
        errorMessage: error?.message,
    }
}
